import axiosBase from "axios";
import axios from "./axiosInstance";
import { PARSE_EXCEL, SIGNED_URL_UPLOAD } from "./apiEndPoints";

interface SignedUrlResponse {
  signedUrl: string;
  key: string;
  fileUrl: string;
}

const PARSE_TIMEOUT_MS = 120_000;

export async function uploadRakeExcel(file: File): Promise<void> {
  const signed = await axios.get<SignedUrlResponse>(SIGNED_URL_UPLOAD, {
    params: {
      fileName: file.name,
      contentType:
        file.type ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  });
  const { signedUrl, fileUrl } = signed.data;

  await axiosBase.put(signedUrl, file, {
    headers: {
      "Content-Type":
        file.type ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  });

  await axios.post(
    PARSE_EXCEL,
    { s3Url: fileUrl },
    { timeout: PARSE_TIMEOUT_MS }
  );
}
